// extracted by mini-css-extract-plugin
export default {"flex-justify":"KXVvP3WOC9xYs0f4jkDy"};